import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { RECENT_SEARCHES_LIMIT } from "@/lib/constants";

export interface Room {
  adults: number;
  children_ages: number[];
}

export interface RecentSearch {
  id: string;
  destination_id: string;
  destination_name: string;
  country_code?: string;
  check_in: string;
  check_out: string;
  rooms: Room[];
  searched_at: string;
}

const initialState: { items: RecentSearch[] } = { items: [] };

const recentSearchesSlice = createSlice({
  name: "recentSearches",
  initialState,
  reducers: {
    addRecent(state, action: PayloadAction<Omit<RecentSearch, "id" | "searched_at">>) {
      const id = `${action.payload.destination_id}-${action.payload.check_in}-${action.payload.check_out}`;
      const existingIdx = state.items.findIndex((s) => s.id === id);
      if (existingIdx >= 0) state.items.splice(existingIdx, 1);
      state.items.unshift({
        ...action.payload,
        id,
        searched_at: new Date().toISOString(),
      });
      if (state.items.length > RECENT_SEARCHES_LIMIT) {
        state.items.length = RECENT_SEARCHES_LIMIT;
      }
    },
    clearRecent() {
      return { items: [] };
    },
  },
});

export const { addRecent, clearRecent } = recentSearchesSlice.actions;
export default recentSearchesSlice.reducer;
